import Http from '@/utils/httpRequest'
import qs from 'qs'

const axios = new Http()
export default {
  // 获取登录，注册页面配置
  getLoginConfig: () => {
    return axios.get('/applet/public/loginConfig')
  },
  // 普通登录接口
  loginIn: data => {
    return axios.post('/Login/dchy/public/LoginIn', data)
  },
  // 退出登录接口
  logOut: data => {
    return axios.get('/Login/dchy/public/Logout', data)
  },
  // Logout
  // 手机号登录接口
  loginInByPhone: data => {
    return axios.post('/Login/dchy/public/loginInByMobilePhone', data)
  },
  // 发送验证码
  sendVerification: data => {
    return axios.get('/validate/public/sendVerification', data)
  },
  // 注册校验接口
  checkRegisterInfo: data => {
    return axios.post('/Login/public/CheckRegisterInfo', data)
  },
  // 注册接口
  register: data => {
    return axios.post('/Login/dchy/public/Register', data)
  },


  // 我的委托列表
  getEntrustList: data => {    
    return axios.get('/cghj/public/getAppletCountCghjb', data)
  },
  // 个人中心卡片信息接口
  getPersonalCenterCard: () => {
    return axios.get('/applet/public/personalCenterCard')
  },

  // 2022-09-30
  // 获取用户信息
  getLoginUserInfo: data => {
    return axios.get('/Login/dchy/public/GetLoginUserInfo',data)
  },
  // 获取个人中心配置
  getPersonConfig: data => {
    return axios.get('/applet/public/personConfig',data)
  },
  // 修改用户信息
  updateUserInfo: data => {
    return axios.post('/Login/dchy/public/updateUserInfo',data)
  },
  // 修改密码
  updatePassword: data => {
    return axios.post('/Login/dchy/public/updatePassword',data)
  },
  // 修改手机号
  updateMobilePhone: data => {
    return axios.post('/Login/dchy/public/updateMobilePhone',data)
  },
  // 忘记密码
  resetPasswordCenter: data => {
    return axios.post('/Login/public/resetPasswordCenter',data)
  },
  // 修改邮箱
  updateEmail: data => {
    return axios.post('/Login/dchy/public/updateEmail',data)
  },
  // 材料中心列表接口
  getMaterialLibrary: data => {
    return axios.post('/onlineServiceProject/dchy/public/getMaterialLibrary',data)
  },
  // 添加材料接口
  addMaterialLibrary: data => {
    return axios.post('/onlineServiceProject/dchy/public/addMaterialLibrary',data)
  },
  // 修改材料接口
  updateMaterialLibrary: data => {
    return axios.post('/onlineServiceProject/dchy/public/updateMaterialLibrary',data)
  },
  // 删除材料接口
  delMaterialLibrary: data => {
    return axios.post('/onlineServiceProject/dchy/public/delMaterialLibrary',data)
  },
  // 文件上传接口
  materialUpload: data => {
    return axios.post('/onlineServiceProject/public/materialUpload',data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    })
  },
  // 忘记密码,通过邮箱或手机号请求验证码
  checkMobileOrEmailSendCode: data => {
    return axios.get('/Login/public/checkMobileOrEmailSendCode',data)
  },
}
